var sb = require('@sb/util')
import store from '@sb/store'
import Emoji from '../components/Emoji.js'
let bowser = require('bowser')
var defaultBubble = require('../../assets/img/bubble_default.svg')

export default {
	props: ['isShow'],
	data () {
		return {
			previewEvent: {},
			displayPreview: false,
			...store.bind(this, ['account', 'agentM', 'convoEventM', 'convoM', 'accountSetting', 'user']),
		}
	},

	watch: {
		accountSetting (n) {
			this.loadGreeting()
		},
	},

	created () {
		this.loadGreeting()
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			if (sb.get(ev, 'type') !== 'message_sent') return

			let bytype = sb.get(ev, 'by.type')
			if (bytype !== 'system' && bytype !== 'agent') return
			this.displayPreview = true
			this.$set(this, 'previewEvent', ev)
		})
	},

	render () {
		if (!this.isShow) return <transition name="fade" />
		let position = sb.get(this.accountSetting, 'desktop_button.position') || 'right'

		if (bowser.mobile) {
			position = sb.get(this.accountSetting, 'mobile_button.position') || position
			let hiddenButtonMobile = sb.get(this.accountSetting, 'mobile_button.hidden')
			if (hiddenButtonMobile) return null
		}
		let hiddenButtonDesktop = sb.get(this.accountSetting, 'desktop_button.hidden')
		if (hiddenButtonDesktop) return null

		let cls = 'widget-layout widget-layout--' + position
		return (
			<transition name="fade">
				<div class={cls}>
					{this.renderPreview()}
					{this.renderButton()}
				</div>
			</transition>
		)
	},

	methods: {
		clearPreview () {
			this.previewEvent = {}
		},

		loadGreeting () {
			// dont show preview if the user has previously closed it
			if (Date.now() - store.closePreviewAt < Ms30Mins) return

			let greeting = sb.get(this.accountSetting, 'greeting', {})
			if (!greeting.message) {
				this.previewEvent = {}
				return
			}

			let byid = greeting.agent_id
			if (!byid) byid = randomAgent(this.agentM).id

			this.$set(this, 'previewEvent', {
				by: { id: byid, type: 'agent' },
				data: { message: { text: greeting.message, format: 'plaintext' } },
			})
			this.displayPreview = true
			return this.previewEvent
		},

		onClick () {
			let lastview = store.lastview
			if (sb.get(lastview, 'view')) {
				// if lastview is list, make sure we have at least one convo or fallback
				// to preview click
				if (lastview.view !== 'list' || sb.size(this.convoM) > 0) {
					return this.$emit('click', Object.assign({}, lastview.opts, { view: lastview.view })) // last view
				}
			}

			// dont have last view => equal preview click
			return this.onPreviewClick()
		},

		onPreviewClick () {
			let convoKey = sb.convoKeyOfEv(this.previewEvent)
			this.closePreview()
			this.$emit('click', { view: 'chat', convoKey })
		},

		renderUnread () {
			var unreadcount = sb.size(sb.filter(this.convoEventM, events => !sb.isConvoSeen(this.user.id, events)))
			if (unreadcount === 0) return null
			return <div class="chat-button--unread">{unreadcount}</div>
		},

		renderPreview () {
			return <transition name="slide-fade">{this.renderPreviewNoTransition()}</transition>
		},

		renderButton () {
			let imgsrc =
				sb.get(this.accountSetting, 'desktop_button.background_image_url') ||
				sb.get(this.accountSetting, 'desktop_button.background_mask_url') ||
				defaultBubble
			let background = sb.get(this.accountSetting, 'background') || DEF_BG
			let position = sb.get(this.accountSetting, 'desktop_button.position') || 'right'

			let imgurl = sb.get(this.accountSetting, 'desktop_button.background_image_url')
			let maskurl = sb.get(this.accountSetting, 'desktop_button.background_mask_url')

			if (bowser.mobile) {
				imgsrc =
					sb.get(this.accountSetting, 'mobile_button.background_image_url') ||
					sb.get(this.accountSetting, 'mobile_button.background_mask_url') ||
					imgsrc
				position = sb.get(this.accountSetting, 'mobile_button.position') || position

				let mobileimgurl = sb.get(this.accountSetting, 'mobile_button.background_image_url')
				let mobilemaskurl = sb.get(this.accountSetting, 'mobile_button.background_mask_url')
				if (mobileimgurl || mobilemaskurl) {
					imgurl = mobileimgurl
					maskurl = mobilemaskurl
				}
			}

			let whitebgcls = 'chat-button--white-bg'
			if (!imgurl && maskurl) whitebgcls += ' chat-button--white-bg--mask-only'
			let imgcontainerstyle = ''
			if (!imgurl && !maskurl) {
				imgcontainerstyle += `
				-webkit-mask-image: url(${DEF_BG_URL}) !important;
				-o-mask-image: url(${DEF_BG_URL}) !important;
				-moz-mask-image: url(${DEF_BG_URL}) !important;
				mask-image: url(${DEF_BG_URL}) !important;
				height: 70px !important;
				width: 70px !important;
				background: ${background} !important;`
			}
			if (imgurl && maskurl) {
				imgcontainerstyle += `
				-webkit-mask-image: url(${maskurl}) !important;
				-o-mask-image: url(${maskurl}) !important;
				-moz-mask-image: url(${maskurl}) !important;
				mask-image: url(${maskurl}) !important;
				background-image: url(${imgurl}) !important;
				background-repeat: no-repeat !important;`
			}

			if (imgurl && !maskurl) {
				imgcontainerstyle += `
				background-image: url(${imgurl}) !important;
				background-repeat: no-repeat !important;`
			}

			if (!imgurl && maskurl) {
				imgcontainerstyle += `
				-webkit-mask-image: url(${maskurl}) !important;
				-o-mask-image: url(${maskurl}) !important;
				-moz-mask-image: url(${maskurl}) !important;
				mask-image: url(${maskurl}) !important;

				height: 70px !important;
				width: 70px !important;
				background: ${background} !important;`
			}

			let cls = 'chat-button chat-button--' + position

			return (
				<div class={cls} vOn:click={this.onClick}>
					<div class={whitebgcls}></div>
					<div class="chat-button--img-container" style={imgcontainerstyle}>
						<img class="chat-button--img" src={imgsrc} vOn:error={this.onChatButtonError} />
					</div>
					{this.renderUnread()}
				</div>
			)
		},

		onChatButtonError (ev) {
			// make sure we just execute one
			if (this._onChatButtonErrorExecuted) return
			this._onChatButtonErrorExecuted = true

			var $el = ev.target
			$el.src = defaultBubble
		},

		renderPreviewNoTransition () {
			if (!this.displayPreview) return null
			let byid = sb.get(this.previewEvent, 'by.display_id', sb.get(this.previewEvent, 'by.id'))
			let agent = sb.cloneDeep(this.agentM[byid]) || {}

			agent.fullname = agent.fullname || sb.get(this.account, 'name') || this.$t('agent')

			agent.avatar_url =
				agent.avatar_url || sb.get(this.account, 'logo_url') || require('../../assets/img/default_avatar.png')

			var tags = this.renderMessagePreview(this.previewEvent, this.$t('sent_you_a_message'))
			if (sb.size(tags) === 0) return null

			let position = sb.get(this.accountSetting, 'desktop_button.position') || 'right'
			if (bowser.mobile) position = sb.get(this.accountSetting, 'mobile_button.position') || position
			let cls = 'widget-preview widget-preview--' + position

			return (
				<div class={cls}>
					<div class="d-flex flex-row pl-3 pt-3 pr-3 pb-3">
						<img class="widget-preview--avatar" src={agent.avatar_url} />
						<div class="widget-preview--content" vOn:click={this.onPreviewClick}>
							<h5 class="widget-preview--title">{agent.fullname}</h5>
							<p class="widget-preview--message">{tags}</p>
						</div>
						<div class="widget-preview--btn-close" vOn:click_stop_prevent={this.closePreview} />
					</div>

					<div class="widget-preview--action" vOn:click={this.onPreviewClick}>
						<h5 class="widget-preview--action-text">{this.$t('chat_now')}</h5>
					</div>
				</div>
			)
		},

		renderMessagePreview (ev, defmsg) {
			defmsg = defmsg || 'Sent you a message'

			let message = sb.get(ev, 'data.message.text')
			var format = sb.get(ev, 'data.message.format')

			// cant display message
			if (format && format !== 'plaintext') message = defmsg
			if (!message && sb.size(sb.get(ev, 'data.message.attachments')) > 0) message = defmsg

			if (!message) return null
			let byType = sb.get(ev, 'by.type')
			var tags = sb.extractText(message).map(tag => {
				if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} byType={byType} />
				return tag.text
			})

			return tags
		},

		closePreview () {
			this.displayPreview = false
			store.closePreview()
			this.$forceUpdate()
		},
	},
}

function randomAgent (agentM) {
	var agents = sb.filter(agentM, ag => ag.type === 'agent')
	return agents[Math.floor(Math.random() * sb.size(agents))]
}

const Ms30Mins = 30 * 60 * 1000

const DEF_BG_URL = 'https://filev4.subiz.com/bubble_11.svg'
const DEF_BG = 'linear-gradient(280.16deg, #0053d3 22.03%, #0265ff 78.2%)'
